export const gender = [
  'Laki-laki',
  'Perempuan'
]

export const maritalStatus = [
  'Kawin',
  'Belum Kawin',
  'Cerai Hidup',
  'Cerai Mati'
]

export const religion = [
  'Islam',
  'Katholik',
  'Kristen',
  'Budha',
  'Hindu',
  'Konghuchu',
  'Lainnya'
]

export const education = [
  'Sekolah Dasar (SD)',
  'Sekolah Menengah Pertama (SMP)',
  'Sekolah Menengah Atas (SMA)',
  'Gelar Diploma (D1/D2/D3)',
  'Sarjana (S1)',
  'Gelar Master (S2)',
  'Gelar Doktor (S3)'
]

export const job = [
  'Belum/Tidak Bekerja',
  'Mengurus Rumah Tangga',
  'Pelajar/Mahasiswa',
  'Pensiunan',
  'Perdagangan',
  'Industri',
  'Konstruksi',
  'Transportasi',
  'Karyawan Swasta',
  'Karyawan BUMN',
  'Karyawan BUMD'
]

export const otherSourceIncome = [
  'Pendapatan Bisnis',
  'Pendapatan Dana',
  'Warisan',
  'Gaji',
  'Orang Tua/Wali'
]

export const jobTitle = [
  'Direktur',
  'Wakil Direktur',
  'Manajer',
  'Komisaris'
]
